import React from "react";
import Loader from "../../Common/Loader";

function RegistrationsCountToday({registrationsCountToday, loading}) {
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    const todayFormatted = new Date().toLocaleDateString('en-US', options);
    return (
        <div className="col-lg-12">
                      <div className="card custom-card" style={{paddingBottom:"10px"}}>
                        <div className="card-body map-card">
                        <div className="item-title">
                <h5 style={{marginBottom:10}}>Registrations Today ({todayFormatted})</h5>
                </div>
                        
    {loading ?(
  <Loader/>
) : (
  <table className="table mb-0 mw-100 color-span">
    <thead>
                <tr>
                <th className="w-50">School</th>
                 <th></th>
                <th className="py-2 px-0" scope="col">Online</th>
                <th className="py-2 px-0" scope="col">Admins</th>
                </tr>
                </thead>
    <tbody>
        {Array.isArray(registrationsCountToday) && registrationsCountToday.map((item, key) => (
                                                <tr key={key}>
          <td className="py-2 px-0">
            <span className="w-50">{item.school_name}</span>
          </td>
          <td>:</td>
          <td className="py-2 px-0">
            <span className="">
            {item.online? item.online?.total_p:"..."}
            </span>
          </td>
          <td className="py-2 px-0">
            <span className="">
            {item.admin? item.admin?.total_p:"..."}
            </span>
          </td>
        </tr>
                                            ))}
                                            {registrationsCountToday === "404" && (<tr>
                                                <td colSpan="3" style={{textAlign: "center"}}>
                                                    No registrations today.
                                                </td>
                                            </tr>)}
       
    </tbody>
  </table>
)}

                        </div>
                      </div>
                    </div>
        
    );
}

export default RegistrationsCountToday;
